import React, { PureComponent } from 'react';
import { isSomething, widgetExpanded, dataHas, fetchStartEndRes } from '../../common/ambient'
import PropTypes from 'prop-types';
import { max, map, pick, mergeAll } from 'ramda'
import FormattedDataPoint from './FormattedDataPoint'

export default class SolarWidget extends PureComponent {
  static propTypes = {
    device: PropTypes.object,
    currentDevice: PropTypes.object.isRequired,
    fetchDeviceData: PropTypes.func
  }
  state = {
    now: false
  }

  render() {
    const { currentDevice, device } = this.props
    const { lastData } = currentDevice
    let widget = <div className="solar-widget hidden" />
    const currentDataHas = dataHas(lastData)
    if (currentDataHas(['solarradiation'])) {
      const from = []
      if (lastData.hl && lastData.hl.solarradiation) {
        const todaysSolarMax = lastData.hl.solarradiation.h
        if (isSomething(todaysSolarMax)) {
          from.push(
            <div key='solar-max' className="from zero">
              <div className="label">
                Today's Peak 
              </div>
              <FormattedDataPoint type={'solarradiation'} value={todaysSolarMax} />
            </div>
          )
        }
        const todaySolarSum = lastData.hl.solarradiation.s
        if (isSomething(todaySolarSum)) {
          // Calculate kJ/m² from W/m² sum
          let solarKJ = todaySolarSum
          
          // Get timezone and calculate seconds elapsed today
          const tz = lastData.tz
          if (tz && lastData.hl.solarradiation.c) {
            const now = moment().tz(tz)
            const startOfDay = now.clone().startOf('day')
            const secondsElapsed = now.diff(startOfDay, 'seconds')
            const reportCount = lastData.hl.solarradiation.c
            
            // Calculate average seconds per report
            const avgSecondsPerReport = reportCount > 0 ? secondsElapsed / reportCount : 0
            
            // Convert W/m² to kJ/m² (W = J/s, so W × seconds = J, then J/1000 = kJ)
            solarKJ = (todaySolarSum * avgSecondsPerReport) / 1000
            from.push(
              <div key='solar-sum' className="from zero">
                <div className="label">
                  Today's Total 
                </div>
                <FormattedDataPoint suff={<>kJ/m<sup>2</sup></>} value={parseInt(solarKJ, 10)} />
              </div>
            )
          }
        }
      }
      widget =
        <div className="solar-widget center-aligned">
          <FormattedDataPoint className='solarmax' type={'solarradiation'} row={lastData} />
          <div className='from-wrap'>
            {from}
          </div>
        </div>
    }
    return widget
  }
}

SolarWidget.displayName = 'SolarWidget'
